import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient, HttpHeaders }from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PostResponse, GetResponseAttachment, Attachment, PostResponseAddAttachment } from '../models/Attachment'

@Injectable({
  providedIn: 'root'
})



export class AttachmentService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  uploadFile(val: any, id:number) : Observable<PostResponse> {
    
    const formData = new FormData();    
    formData.append('formFile', val, val.name);
    formData.append('kaizenId', JSON.stringify(id));
    //note: do not use the httpOptions.  This will cause a 415 invalid media type error
    return this.http.post<PostResponse>(this.APIURL + '/BlobStorage', formData);
  }


  viewFile(attachmentName:string, kaizenId: number): Observable<any>
  {
    var filename = kaizenId.toString() + '/' + attachmentName;
    //set the response type to text since a ulrl string si returned from api
    let downloadHTTPOptions:Object = 
    {
      headers: new HttpHeaders({
          'Content-Type': 'application/json'
      }),
      responseType: 'text'
    }
    return this.http.get<any>(this.APIURL + '/BlobStorage/?fileName=' + filename, downloadHTTPOptions);

}
  deleteFile(kaizenId: Number, fileName: string): Observable<boolean>
  {
    return this.http.delete<boolean>(this.APIURL + '/BlobStorage/?fileName=' + fileName +'&kaizenId=' + kaizenId.toString());
 
  }

  getAttachmentsByKaizenId(id:number): Observable<GetResponseAttachment> {
    return this.http.get<GetResponseAttachment>(this.APIURL + '/KaizenAttachment/GetKaizenAttachmentsByKaizen/' + id, this.httpOptions);
  }
 
  addAttachment(val:Attachment): Observable<PostResponseAddAttachment>
  {
    return this.http.post<PostResponseAddAttachment>(this.APIURL + '/KaizenAttachment', val, this.httpOptions);
  }


  deleteAttachment(id:number):Observable<number> 
  {
    return this.http.delete<number>(this.APIURL+'/KaizenAttachment/' + id);    
  }
 

}